function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import RelativeContainerOrg from "../../organisms/RelativeContainerOrg";
import SurfaceOrg from "../../organisms/SurfaceOrg";
import { StyledAbsoluteContainerOrg, StyledTextareaMol } from "./PromptMol.styled";
function PromptMol(_ref) {
  var _textArea$backgroundC;
  var header = _ref.header,
    textArea = _ref.textArea,
    textAreaButtons = _ref.textAreaButtons,
    surfaceColor = _ref.surfaceColor,
    footer = _ref.footer;
  return /*#__PURE__*/React.createElement(SurfaceOrg, _extends({
    spacingSpace: 0
  }, surfaceColor), header, /*#__PURE__*/React.createElement(RelativeContainerOrg, null, /*#__PURE__*/React.createElement(StyledTextareaMol, textArea), /*#__PURE__*/React.createElement(StyledAbsoluteContainerOrg, {
    rightUnit: 16,
    bottomUnit: 1,
    leftUnit: 8,
    $backgroundColor: (_textArea$backgroundC = textArea.backgroundColor) !== null && _textArea$backgroundC !== void 0 ? _textArea$backgroundC : "backgroundLight"
  }, textAreaButtons)), footer);
}
export default PromptMol;